import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="list"
export default class extends Controller {
  static targets = ["batchActions", "mainCheckbox", "rowCheckbox", "deleteLink"]

  connect() {
    this.updateBatchActions()
  }

  toggleAll(event) {
    const checked = event.target.checked
    this.rowCheckboxTargets.forEach(checkbox => {
      checkbox.checked = checked
    })
    this.updateBatchActions()
  }

  toggleRow() {
    // Update main checkbox state
    const allChecked = this.rowCheckboxTargets.every(cb => cb.checked)
    const someChecked = this.rowCheckboxTargets.some(cb => cb.checked)

    if (this.hasMainCheckboxTarget) {
      this.mainCheckboxTarget.checked = allChecked
      this.mainCheckboxTarget.indeterminate = someChecked && !allChecked
    }

    this.updateBatchActions()
  }

  updateBatchActions() {
    const selectedCheckboxes = this.rowCheckboxTargets.filter(cb => cb.checked)
    const selectedIds = selectedCheckboxes.map(cb => cb.dataset.id)

    // Toggle visibility of batch actions
    if (this.hasBatchActionsTarget) {
      if (selectedIds.length > 0) {
        this.batchActionsTarget.classList.remove('hidden')
      } else {
        this.batchActionsTarget.classList.add('hidden')
      }
    }

    // Update delete link with selected IDs
    if (this.hasDeleteLinkTarget) {
      const baseUrl = this.deleteLinkTarget.dataset.baseUrl || '/admin/customers/batch_delete'
      const idsParam = selectedIds.join(',')
      this.deleteLinkTarget.href = `${baseUrl}?ids=${idsParam}`

      // Update count in button text
      const countText = this.deleteLinkTarget.querySelector('[data-count]')
      if (countText) {
        countText.textContent = selectedIds.length
      }
    }
  }
}
